import React, { useRef } from "react";
import { message } from "antd";
import { useStaffModel } from "../staffModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { DetailType } from "../../../../types/ScmEnums"
import useGlobalModel, { transOptions } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function DetailDrawer() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, rolesAllList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)


    const { detailDrawer: visible, detailType, addFormVal, selectedRow, setDetailDrawer, insertDetail, editDetail } = useStaffModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setDetailDrawer(false);
    }
    const getRolesList = (rolesData: any, rolesCodes: any) => {
        const filterDetailList = rolesData.filter((el: any) => !!rolesCodes.find((ele: any) => ele === el.id))?.map((item: any) => ({ name: item.name, roleId: item.id, code: item.code }))
        return filterDetailList
    }
    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            let { roleIdLists } = res
            const roleIdList = roleIdLists ? getRolesList(rolesAllList, roleIdLists) : null
            if (detailType == DetailType.add) {
                insertDetail({ ...res, roleIdList }).then(res => res && onCancel())
            } else if (detailType == DetailType.edit) {
                editDetail({ ...res, roleIdList, id: selectedRow.id }).then(res => res && onCancel())
            } else {
                onCancel()
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const staffOptions = (list: any[]) => {
        return list.length != 0 ? list.map(item => ({ label: item.name, value: item.id })) : []
    }
    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        formValues: detailType == DetailType.add ? addFormVal : selectedRow,
        disabled: detailType == DetailType.look,
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "员工姓名",
                fieldLabel: Locale["Employee"],
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入姓名" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "员工账号",
                fieldLabel: Locale["Employee Account"],
                fieldName: "account",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "账号密码",
                fieldLabel: Locale["Account Password"],
                fieldName: "password",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "所属岗位",
                fieldLabel: Locale["Post"],
                fieldName: "title",
                span: 24,
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "系统角色",
                fieldLabel: Locale["System Role"],
                fieldName: "roleIdLists",
                span: 24,
                options: staffOptions(rolesAllList),
                mode: "multiple",
                allowClear: true,
                showSearch: true
            }
        ]
    };
    const titleType:any = {
        add: Locale["Add Employee"],
        edit: Locale["Edit Employee"],
        look: Locale["View Employee"],

        // look: "查看",
        // add: "新增",
        // edit: "编辑",
        // look: "查看",
    }
    return (
        <YHDrawer
            {...{
                // title: `员工${detailType == DetailType.add ? "新增" : "编辑"}`,
                title: titleType[detailType],
                visible,
                onCancel,
                okText: Locale["Save"],
                cancelText: Locale["Back"],
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
